import { Terms } from '@/interfaces/terms';
import { TermsResource, termsResource } from '@/resources/terms.resource';
import { EntityModule } from './entity.module';

export class TermsModule extends EntityModule<Terms, TermsResource> {
  constructor() {
    super(termsResource);

    this.actions = {
      ...this.actions,
      /**
       * Pobieram aktualnie wymagane regulaminy
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      current: async (context: any, data: { required: boolean }) => {
        const list = await this.resource.termsCurrent(data.required);
        context.commit('saveList', list);
        context.commit('saveCount', list.length);
      }
    };
  }
}

export default new TermsModule();
